import { render } from "./systemSchool.vue?vue&type=template&id=a69dc0b0&scoped=true"
import script from "./systemSchool.vue?vue&type=script&lang=js"
export * from "./systemSchool.vue?vue&type=script&lang=js"

import "./systemSchool.vue?vue&type=style&index=0&id=a69dc0b0&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a69dc0b0"]])

export default __exports__